<template>
  <img :src="defaultSrc" :srcset="srcSet">
</template>

<script>
  export default {
    name: 'lc-image',

    props: [
      'image',
    ],

    computed: {
      defaultSrc() {
        return this.image.large_url;
      },

      srcSet() {
        return [
          `${this.image.medium_url} 1x`,
          `${this.image.large_url} 2x`,
        ].join(',');
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/LcImage.vue